const translations = {
    cancel: 'Cancel',
    flightControllerSerial: 'Flight Controller Serial',
    flightControllerSerialMax: 'Flight controller serial cannot exceed {{charMax}} characters',
    make: 'Drone Make',
    model: 'Drone Model',
    nickname: 'Drone Name',
    nicknameMax: 'Drone Name cannot exceed {{charMax}} characters',
    notProvided: 'Not provided',
    registrationNumber: 'Registration Number',
    registrationNumberMax: 'Registration number cannot exceed {{charMax}} characters',
    saving: 'Saving…',
    selectMake: 'Select a make',
    selectModel: 'Select a model',
    serialNumber: 'Serial Number',
    serialNumberMax: 'Serial number cannot exceed {{charMax}} characters',
    swathWidth: 'Swath Width Meters'
};

export default translations;
